export default '/static/frontend/ReachDigital/12gobiking/dist/assets/thuiswinkel-47004452.svg'